// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_10992","item":"_5828","center":"_7754","custom":"_6554","hasMore":"_1556"};